'use client';

import AppUrlListener from './AppUrlListener';
import EPassiMobileReturnHandler from './components/epassi/EPassiMobileReturnHandler';
import AppPaymentReturnHandler from './components/paymentRedirectHandler/AppPaymentReturnHandler';

// Groups the always-mounted, render-null app-level listeners (deep-link URL
// handling, the iOS Epassi return handler and the custom-scheme payment return)
// so App.tsx mounts them as one unit.
const AppNativeHandlers: React.FC = () => (
  <>
    <AppUrlListener />
    <EPassiMobileReturnHandler />
    <AppPaymentReturnHandler />
  </>
);

export default AppNativeHandlers;
